!((document, Drupal, $) => {
  'use strict';

  /**
   * Use this to describe what your behavior does.
   */
  Drupal.behaviors.mainMenu = {
    attach: function (context) {

      let logo = $('.loro-logo', context);
      let navbar = $('.main-menu', context);

      const html = $('html');
      let isResponsive = false;

      const offsetDistance = html.hasClass('alert') ? 72 : 50;


      if ($(document).scrollTop() > offsetDistance) {
        logo.addClass('loro-logo--reduced');
        navbar.addClass('offset');
      } else {
        logo.removeClass('loro-logo--reduced');
        navbar.removeClass('offset');
      }

      $(document).scroll(function () {
        if ($(this).scrollTop() > offsetDistance) {
          logo.addClass('loro-logo--reduced');
          navbar.addClass('offset');
        }
        else {
          logo.removeClass('loro-logo--reduced');
          navbar.removeClass('offset');
        }
      });


      let linkElement = $('.main-menu__list--level-0 li', context);
      let overlay = $('.overlay', context);

      linkElement.on('mouseenter', function () {
        if ($(this).find('.menu-toggler').length) {
          $(this).addClass('hovered');
          overlay.addClass('overlay--active');
        }
      });

      linkElement.on('mouseleave', function () {
        if ($(this).hasClass('hovered')) {
          $(this).removeClass('hovered');
          overlay.removeClass('overlay--active');
        }
      })

      let hamburgerToggler = $('.hamburger', context);
      hamburgerToggler.on('click', function () {
        $(this).toggleClass('hamburger--open');
        $(this).next().toggleClass('open');
        $('body').toggleClass('prevent-scrolling');
      });

      let responsiveToggler = $('.responsive-toggler', context);
      responsiveToggler.bind('click', function () {
        responsiveToggler.not(this).removeClass('is-open');
        responsiveToggler.not(this).next().find('.second-level').removeClass('is-open');
        $(this).toggleClass('is-open');
        $(this).next().find('.second-level').toggleClass('is-open');
      });

      /**
       * If we are on the second level, we open the corresponding block
       * in the mobile/responsive menu
       */
      let secondLevelLinks = $('.second-level a.is-active', context);
      if (secondLevelLinks.length === 1) {
        let parent = secondLevelLinks.parents('.menu-toggler');
        parent.prev().addClass('is-open');
        parent.find('.second-level').addClass('is-open');
      }

      (function () {
        var throttle = function (type, name, obj) {
          obj = obj || window;
          var running = false;
          var func = function () {
            if (running) {
              return;
            }
            running = true;
            requestAnimationFrame(function () {
              obj.dispatchEvent(new CustomEvent(name));
              running = false;
            });
          };
          obj.addEventListener(type, func);
        };

        /* init - you can init any event */
        throttle('resize', 'optimizedResize');
      })();

      window.addEventListener('optimizedResize', function () {
        toggleResponsiveClass(html);
      });


      /**
       * Adds a extra class in the case the viewport width is below a breakpoint
       * @param {object} el A DOM element (most probably 'HTML' tag)
       * @return {void}
       */
      function toggleResponsiveClass(el) {
        if (window.innerWidth < 860) {
          el.addClass('responsive');
          isResponsive = true;
          if (hamburgerToggler.hasClass('hamburger--open')) {
            $('body').addClass('prevent-scrolling');
          }
        }
        else {
          el.removeClass('responsive');
          $('body').removeClass('prevent-scrolling');
          isResponsive = false;
        }
      }

      toggleResponsiveClass(html);
    }
  };
})(document, Drupal, jQuery);
